
<div class="container mt-5">

    <div class="page-header page-produit mb-4" *ngIf="dispoJob && actualJob['name_'+translate.store.currentLang] && actualJob['description_'+translate.store.currentLang]">
        <h1 class="pt-5 pb-3">{{actualJob['name_'+translate.store.currentLang]}}</h1>
        <p class="lead text-muted mb-4" style="font-size:15px;">{{'Posté le' | translate}} {{language.getDate(actualJob.date)}}</p>
    </div>

    <div class="row my-5 pb-3">
        <div class="col-lg-8 mb-5 mb-lg-0" *ngIf="dispoJob && actualJob['name_'+translate.store.currentLang] && actualJob['description_'+translate.store.currentLang]">
            <div class="text" [innerHTML]="actualJob['description_'+translate.store.currentLang]"></div>
            <hr class="my-4">
            <div>
                <a class="btn btn-simple mr-3" [routerLink]="language.navigateAccordingToLang(['/jobs'])" title="back">{{'Retour aux annonces' | translate}}</a>
                <button class="btn btn-action" (click)="modalPostule()">{{'Postuler à cette offre' | translate}}</button>
            </div>
        </div>
        <div class="col-lg-8 mb-5 mb-lg-0" *ngIf="!dispoJob || !actualJob['name_'+translate.store.currentLang] || !actualJob['description_'+translate.store.currentLang]">
            <h1 class="pt-5 pb-3">{{'Annonce indisponible' | translate}}</h1>
            <p>{{'Cette annonce n\'existe pas ou n\'est plus disponible' | translate}}</p>
            <hr class="my-4">
            <div>
                <a class="btn btn-simple mr-3" [routerLink]="language.navigateAccordingToLang(['/jobs'])" title="back">{{'Retour aux annonces' | translate}}</a>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="row">
              <div class="col-12">
                  <div class="bg-light p-4 lastArticles">
                    <h2>{{'Autres annonces' | translate}}</h2>
                    <div class="lastArticle" *ngFor="let job of otherJobs" [routerLink]="language.navigateAccordingToLang(['/jobs/'+formateJobLink(job.id,job['name_'+translate.store.currentLang])])" title="job"><div *ngIf="job['name_'+translate.store.currentLang] && job['description_'+translate.store.currentLang]">
                        <div class="title">{{job['name_'+translate.store.currentLang]}}</div>
                        <div class="date text-muted">{{'Posté le' | translate}} {{language.getDate(job.date)}}</div>
                    </div></div>
                    <p *ngIf="!otherJobs.length" class="mb-0 mt-3">
                        {{'Pas d\'autres annonces pour le moment' | translate}}
                    </p>
                  </div>
              </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="postuleModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" *ngIf="actualJob['name_'+translate.store.currentLang]">{{'Postuler pour' | translate}}: {{actualJob['name_'+translate.store.currentLang]}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="lastName">{{'Nom' | translate}}:</label>
                    <input type="text" name="lastName" id="lastName" class="form-control" [(ngModel)]="formDatas.lastName">
                    <small *ngIf="formErrors[0]" class="text-danger mt-1">{{'Le champ ci-dessus est vide ou incorrect' | translate}}</small>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="firstName">{{'Prénom' | translate}}:</label>
                    <input type="text" name="firstName" id="firstName" class="form-control" [(ngModel)]="formDatas.firstName">
                    <small *ngIf="formErrors[1]" class="text-danger mt-1">{{'Le champ ci-dessus est vide ou incorrect' | translate}}</small>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="email">{{'Email' | translate}}:</label>
                    <input type="text" name="email" id="email" class="form-control" [(ngModel)]="formDatas.email">
                    <small *ngIf="formErrors[2]" class="text-danger mt-1">{{'Le champ ci-dessus est vide ou incorrect' | translate}}</small>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="description">{{'Description' | translate}}:</label>
                    <textarea type="text" name="description" id="description" class="form-control" [(ngModel)]="formDatas.description"></textarea>
                    <small *ngIf="formErrors[3]" class="text-danger mt-1">{{'Le champ ci-dessus est vide ou incorrect' | translate}}</small>
                </div>
            </div>
                <div class="col-6">
                <div class="form-group">
                    <label for="cv">{{'CV' | translate}}:</label>
                    <div class="dndFile">
                        <p class="text-center text-muted dndLabel" *ngIf="!formDatas.cv">
                            {{'Sélectionnez un fichier' | translate}}<br>
                            {{'ou' | translate}}<br>
                            {{'Faites-en glisser un ici' | translate}}
                        </p>
                        <p class="text-center text-muted dndSelected"  *ngIf="formDatas.cv">
                            {{'Vous avez sélectionné' | translate}}<br><u class="font-weight-normal">{{filenames.cv}}</u>
                        </p>
                        <div class="loadingFile text-muted" *ngIf="filenames.cv == 'loading'">
                            <i class="fa fa-spinner fa-pulse"></i>
                        </div>
                        <input accept=".pdf" type="file" id="cv" (change)="addPDF($event, 'cv')" title=" ">
                    </div>
                    <small *ngIf="formErrors[4]" class="text-danger mt-1">{{'Le champ ci-dessus est vide ou incorrect' | translate}}</small>
                    <small *ngIf="filenames.cv=='error'" class="text-danger mt-1">{{'Le fichier n\'est pas valide, veuillez sélectionner un fichier PDF' | translate}}</small>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="coverLetter">{{'Lettre de motivation' | translate}}:</label>
                    <div class="dndFile">
                        <p class="text-center text-muted dndLabel" *ngIf="!formDatas.coverLetter">
                            {{'Sélectionnez un fichier' | translate}}<br>
                            {{'ou' | translate}}<br>
                            {{'Faites-en glisser un ici' | translate}}
                        </p>
                        <p class="text-center text-muted dndSelected"  *ngIf="formDatas.coverLetter">
                            {{'Vous avez sélectionné' | translate}}<br><u class="font-weight-normal">{{filenames.coverLetter}}</u>
                        </p>
                        <div class="loadingFile text-muted" *ngIf="filenames.cv == 'loading'">
                            <i class="fa fa-spinner fa-pulse" *ngIf="filenames.coverLetter == 'loading'"></i>
                        </div>
                        <input accept=".pdf" type="file" id="coverLetter" (change)="addPDF($event, 'coverLetter')" title=" ">
                    </div>
                    <small *ngIf="formErrors[5]" class="text-danger mt-1">{{'Le champ ci-dessus est vide ou incorrect' | translate}}</small>
                    <small *ngIf="filenames.coverLetter=='error'" class="text-danger mt-1">{{'Le fichier n\'est pas valide, veuillez sélectionner un fichier PDF' | translate}}</small>
                </div>
            </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{'Annuler' | translate}}</button>
        <button type="button" class="btn btn-action" (click)="postForJob()" id="sendButton">{{'Envoyer' | translate}}</button>
      </div>
    </div>
  </div>
</div>


<div  class="modal fade" id="postuleModalSuccess" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border:none;padding: 8px 15px;">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{modalText}}.
      </div>
      <div class="modal-footer" style="border:none;padding-top: 8px;">
        <button type="button" class="btn btn-primary" onclick="$('#postuleModalSuccess').modal('hide')">Ok</button>
      </div>
    </div>
  </div>
</div>
